<div class="usage-cards row space">
  <mat-card appearance="filled" class="usage-card">
    <div class="header">
      <h2>Disk usage</h2>
    </div>
    <div class="column">
      <div class="usage row">
        <div class="label row">
          <fa-icon [icon]="['fas', 'house']" size="lg"></fa-icon>
          <span>Plan usage (db excl.)</span>
        </div>
        <span>
          <span class="bold">{{ diskUsage().quotaSnapshot.blockUsed | bytesToSize }} </span>
          / {{ diskUsage().quotaSnapshot.blockHard | bytesToSize }}</span
        >
      </div>

      <mat-progress-bar mode="determinate" [value]="homeDirPercentage()"></mat-progress-bar>
      <div class="hint">
        <span>Updates automatically every {{ updateInterval() }} minutes.</span>
      </div>
    </div>
    <div class="column">
      <div class="usage row">
        <div class="label row">
          <fa-icon [icon]="['fas', 'database']" size="lg"></fa-icon>
          <span>Total (db incl.)</span>
        </div>

        <span>
          <span class="bold">{{ siteTotal() | bytesToSize }}</span>
          / {{ diskUsage().quotaSnapshot.blockHard | bytesToSize }}</span
        >
      </div>

      <mat-progress-bar mode="determinate" [value]="siteTotalPercentage()"></mat-progress-bar>
      <div class="hint row">
        <span
          >Last updated: <b>{{ lastUpdated() }}</b>
        </span>
        @let downtime = syncDowntime();
        <button
          matRipple
          class="icon-button"
          [matTooltip]="`The disk space data can be refreshed every ${downtime ? downtime / 60 : '30'} minutes`"
          [disabled]="isDisabled()"
          (click)="syncDiskUsage()"
        >
          <fa-icon [icon]="['fas', 'arrows-rotate']" size="lg" class="btn-icon"></fa-icon>
        </button>
      </div>
    </div>
    <button matButton="outlined" class="app-btn-small">
      <fa-icon matPrefix [icon]="['fas', 'pen']" size="sm"></fa-icon>
      Change quota
    </button>
  </mat-card>

  <mat-card appearance="filled" class="usage-card">
    <div class="header row">
      <h2>CPU</h2>
      <app-input-field
        id="cpu-select"
        type="select"
        [options]="periodOptions"
        [formControl]="cpuPreset"
      ></app-input-field>
    </div>
    @if (cpuComputedUsage().length > 0) {
      <div class="chart-container">
        <canvas
          baseChart
          [data]="lineChartData"
          [options]="lineChartOptions"
          [type]="lineChartType"
        ></canvas>
      </div>
    } @else {
      <div class="message column">
        <p>No data</p>
      </div>
    }
  </mat-card>

  <mat-card appearance="filled" class="usage-card">
    <div class="header row">
      <h2>Bandwidth</h2>
      <app-input-field
        id="bandwidth-select"
        type="select"
        [options]="periodOptions"
        [formControl]="bandwidthPreset"
      ></app-input-field>
    </div>
    <div class="circle-text row">
      <div class="spinner">
        <mat-progress-spinner
          diameter="126"
          class="bandwidth-circle"
          mode="determinate"
          [value]="bandwidthPercent()"
        ></mat-progress-spinner>
        <span class="spinner-text">{{ bandwidthPercent() }}%</span>
        <div class="spinner-background"></div>
      </div>

      <div class="texts">
        <span
          ><span class="bold">{{ bandwidthTotalUsage() | bytesToSize }}</span> /
          {{ bandwidthLimit() | bytesToSize }}</span
        >
      </div>
    </div>
    <p class="hint">The limit resets on every 1st of the month.</p>
  </mat-card>
</div>
